import React from 'react';
import type { ResizeHandleProps } from '../types';

/**
 * Desktop resize handle component
 * Memoized component for sidebar resize handle
 */
export const ResizeHandle: React.FC<ResizeHandleProps> = React.memo(
  ({ isResizing, onPointerDown }) => (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize chat list"
      onPointerDown={onPointerDown}
      className="absolute top-0 right-0 z-10 h-full w-4 -mr-2 cursor-col-resize touch-none select-none flex justify-center"
      style={{ touchAction: 'none' }}
      title="Drag to resize chat list"
    >
      <div
        className={`h-full w-1 rounded-full transition-colors ${
          isResizing ? 'bg-primary' : 'bg-transparent group-hover:bg-primary/40 hover:bg-primary/30'
        }`}
      />
    </div>
  )
);

ResizeHandle.displayName = 'ResizeHandle';
